import type { FaireProductEntity } from "../../entity_types/product";

export const p_8j423sz5sy: FaireProductEntity = {
  token: "p_8j423sz5sy",
  type: "product",
  name: "Olive Jar Cocktail Garnish Holiday Ornament Christmas Decor",
  brandToken: "b_3b15ceb1",
  brandName: "Love & Victory",
  imageUrl:
    "https://cdn.faire.com/fastly/2d2dfe9ca1c21dfaf207b76f688364598583052e1a7c583c9a9f902f8eec6002.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3b658d6429973ccd6dcfdaf11f98b1303bca4d0915dcf820a5e04088cd59058.jpeg",
    "https://cdn.faire.com/fastly/3820970ef5c2bc0ae54922b29efdb2dbdd722430fbabf0cd8771ef05237e0119.jpeg",
    "https://cdn.faire.com/fastly/35fa3bc0cd0a8ac4bc7acdb9bb7d29a0b236112a543ce26a88f10ebcba5dc585.jpeg",
  ],
  priceDollars: 12,
  description:
    "No cocktail enthusiast's Christmas tree is complete without this hand-blown glass jar of olives. With a hand-painted jar and life-like olives, this ornament looks like the real deal! The perfect gift for yourself or your favorite Martini lover!\n\nComes packaged in a custom-made box printed with a retro holiday design that’s just too good to hide with wrapping paper.\n\n5.5 x 2\" glass ornament.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:16.991Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
